import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import claudia from './sidebarItems/claudia';

export const getSidebarItems = (
  accountId,
  locale = 'pt_BR',
  claudiaOnly = false,
  flags = {},
  { hasProjects = true, isHubAdmin = false } = {}
) => ({
  primaryMenu: primaryMenu(accountId, locale, claudiaOnly),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId, flags, claudiaOnly),
    campaigns(accountId),
    settings(accountId, claudiaOnly),
    notifications(accountId),
    claudia(accountId, { hasProjects, isHubAdmin }),
  ],
});
